var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHpdAffidavits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3945_9426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0.923828V4.98537C18 5.53921 18.4615 6.00075 19.0154 6.00075H23.0769",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95386 2.9546C8.95386 1.84691 9.87693 0.923828 10.9846 0.923828H18.0923L23.1692 6.00075V17.0777C23.1692 18.1854 22.2462 19.1084 21.1385 19.1084H19.0154",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76922 14.7686H0.923065L9.23076 6.46094L17.5384 14.7686H15.6923",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76923 14.7695V21.2311C2.76923 22.2465 3.6 23.0772 4.61538 23.0772H13.8461C14.8615 23.0772 15.6923 22.2465 15.6923 21.2311V14.7695",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46152 23.076V17.5376C6.46152 16.5222 7.29229 15.6914 8.30767 15.6914H10.1538C11.1692 15.6914 12 16.5222 12 17.5376V23.076",
    stroke: "#ED7047",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3945_9426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpdAffidavits);
export default __webpack_public_path__ + "static/media/hpd-affidavits.20a0d62769d256952c306c65fe12cbb9.svg";
export { ForwardRef as ReactComponent };